import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import '../styles/Search.scss'
import { useDebounce } from 'util/hooks'

type ListOpts = {
  key: string,
  value: string
}

type SearchOpts = {
  url: string,
  label?: string,
  filter: string,
  filterType?: 'filter' | 'filter_like' | 'filter_not' | 'filter_or',
  fields: string,
  selected: string,
  quantity?: number,
  match?: string[],
  defaultValue?: string,
  defaultParams?: { [x: string]: string },
  options: { returnKey: string, renderValue: string | ((item: any) => string) },
  required?: boolean,
  onSelect: (id: string | number, list?: ListOpts[]) => void
}
const Search: React.FC<SearchOpts> =
({
  url, label, filter, filterType = 'filter',
  fields, quantity, match, options, onSelect, required, selected, defaultParams, defaultValue
}) => {
  const [search, setSearch] = useState('')
  const [list, setList] = useState<ListOpts[]>([])

  const debouce = useDebounce()

  function formatter (results: any[], returnKey: string): void {
    const { renderValue } = options
    setList(results.map(item => ({
      key: item[returnKey],
      value: typeof renderValue === 'string' ? item[renderValue] : renderValue(item)
    })))
  }

  function handleClick (key: string): void {
    const find = list.find(item => item.key === key)
    if (find) {
      setSearch(find.value || '')
      onSelect(key, list)
      setList([])
    }
  }

  function handleSearch (search: string): void {
    debouce(() => {
      const _filter = `${filterType}[${filter}]`

      const regexStart = match?.find(opt => opt === 'start') ? '^' : ''
      const regexEnd = match?.find(opt => opt === 'end') ? '$' : ''

      const params = {
        ...(defaultParams || {}),
        page: 1,
        fields: fields,
        limit: quantity || 5,
        [_filter]: `${regexStart}${search}${regexEnd}`
      }

      if (search) {
        Axios
          .get(url, { params })
          .then(res => res.data)
          .then(res => {
            if (res?.status === 'success' && res.data) {
              formatter(res.data, options.returnKey)
            }
          })
      }
    }, 500)
  }

  useEffect(() => {
    if (defaultValue) {
      setSearch(defaultValue)
    }
  }, [defaultValue])

  useEffect(() => {
    if (!selected || selected === '0') {
      setSearch('')
    }
  }, [selected])

  return (
    <div className="row search">
      <input
        type="text"
        value={search}
        required={required}
        onChange={(e): void => {
          setSearch(e.target.value)
          onSelect('')
          handleSearch(e.target.value)
        }}
      />
      {
        list.length > 0 &&
        <div className="search-box">
          {
            list.map(item => {
              return (
                <div
                  key={item.key}
                  onClick={(): void => handleClick(item.key)}
                  className={`search-item ${selected === item.key ? 'active' : ''}`}
                >
                  { item.value }
                </div>
              )
            })
          }
        </div>
      }
    </div>
  )
}

export default Search
